import reducer from './reducers';

export { default as authOperations } from './operations';
export { default as authSelectors } from './selectors';
export { default as authSagas } from './sagas';
export { default as authTypes } from './types';

export default reducer;
